import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=6b528068&scoped=true&"
import script from "./quit.vue?vue&type=script&lang=js&"
export * from "./quit.vue?vue&type=script&lang=js&"
import style0 from "./quit.vue?vue&type=style&index=0&id=6b528068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b528068",
  null
  
)

export default component.exports